import { render, staticRenderFns } from "./DoctorsSettingSelector.vue?vue&type=template&id=75105371&scoped=true"
import script from "./DoctorsSettingSelector.vue?vue&type=script&lang=js"
export * from "./DoctorsSettingSelector.vue?vue&type=script&lang=js"
import style0 from "./DoctorsSettingSelector.vue?vue&type=style&index=0&id=75105371&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75105371",
  null
  
)

export default component.exports